<template>
  <div :class="classes" @click="$emit('click')">
    <v-icon @click.stop="$emit('click')">{{ arrowIcon }}</v-icon>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from "vue"
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js"

export type ArrowDirection = "left" | "right"

export default defineComponent({
  name: "CarouselArrow",
  props: {
    direction: {
      type: String as PropType<ArrowDirection>,
      required: true,
    },
    hide: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const arrowIcon =
      props.direction === "left" ? mdiChevronLeft : mdiChevronRight

    const classes = computed(() => [
      {
        hide: props.hide,
      },
      [props.direction],
      "arrow",
      "animate-fade",
    ])

    return {
      arrowIcon,
      classes,
    }
  },
})
</script>

<style scoped>
/*noinspection CssUnusedSymbol*/
.arrow {
  position: absolute;
  height: 100%;
  width: 48px;
  top: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 2;
}

/*noinspection CssUnusedSymbol*/
.arrow.left {
  background: linear-gradient(to left, #f8f8f800 0%, #f8f8f8 70%);
  left: 0;
  justify-content: start;
}

/*noinspection CssUnusedSymbol*/
.arrow.right {
  background: linear-gradient(to right, #f8f8f800 0%, #f8f8f8 70%);
  right: 0;
  justify-content: end;
}

/*noinspection CssUnusedSymbol*/
.arrow.hide {
  opacity: 0;
  pointer-events: none;
}

/*noinspection CssUnusedSymbol*/
.arrow.animate-fade {
  transition: opacity 0.3s ease;
}
</style>
